function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
var prefix = 'Vod';
var PlayState = function () {
    function PlayState(video, url) {
        _classCallCheck(this, PlayState);
        this.video = video;
        this.url = url;
        this.key = prefix + this.url + ' ';
    }
    _createClass(PlayState, [
        {
            key: 'startRecord',
            value: function startRecord() {
                var _this = this;
                this.timer = window.setInterval(function () {
                    _this.set(_this.key, _this.video.currentTime);
                }, 1000);
            }
        },
        {
            key: 'getLastState',
            value: function getLastState() {
                var lastTime = this.get(this.key);
                return lastTime;
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
            }
        },
        {
            key: 'set',
            value: function set(key, val) {
                window.sessionStorage.setItem(key, val);
            }
        },
        {
            key: 'get',
            value: function get(key) {
                return window.sessionStorage.getItem(key);
            }
        },
        {
            key: 'del',
            value: function del(key) {
                window.sessionStorage.removeItem(key);
            }
        },
        {
            key: 'clear',
            value: function clear() {
                window.sessionStorage.clear();
            }
        }
    ]);
    return PlayState;
}();
export default PlayState;